import Link from "next/link";
import router from "next/router";
import { VFC } from "react";

import { CurrentUser } from "lib/type";

import { VscSettingsGear } from "react-icons/vsc";

type MyPageHeaderProps = {
  user: CurrentUser;
};

const MyPageHeader: VFC<MyPageHeaderProps> = ({ user }) => {
  if (!user) return <p>ユーザー情報の取得に失敗しました。</p>;
  const currentPath = router.asPath;

  const { uid, color } = user;

  return (
    <section className="my-6 md:container lg:px-0">
      {user ? (
        <Link href={`/users/${user.uid}/settings`}>
          <a className="mb-6 inline-flex items-center px-4 md:px-0">
            <VscSettingsGear className="mr-1" />
            プロフィール設定
          </a>
        </Link>
      ) : (
        <div className="h-12"></div>
      )}
      <nav className="relative">
        <ul
          className="before:border-light-800 relative flex
              items-center before:absolute before:bottom-0 before:left-0 before:z-10 before:h-2
              before:w-full before:border-b-4 before:border-solid"
        >
          <li
            className="relative z-10 border-b-4 border-solid"
            style={{
              borderColor:
                `/users/${uid}` === currentPath ? color : "transparent",
            }}
          >
            <Link href={`/users/${uid}`} prefetch={false}>
              <a className="block px-4 py-2">ホーム</a>
            </Link>
          </li>
          <li
            className="relative z-10 border-b-4 border-solid"
            style={{
              borderColor:
                `/users/${uid}/like` === currentPath ? color : "transparent",
            }}
          >
            <Link href={`/users/${uid}/like`}>
              <a className="block px-4 py-2">いいね</a>
            </Link>
          </li>
          <li
            className="relative z-10 border-b-4 border-solid"
            style={{
              borderColor:
                `/users/${uid}/follow` === currentPath ? color : "transparent",
            }}
          >
            <Link href={`/users/${uid}/follow`}>
              <a className="block px-4 py-2">フォロー中</a>
            </Link>
          </li>
        </ul>
      </nav>
    </section>
  );
};

export default MyPageHeader;
